import { SiteNavbar } from '@/components/sections/site-navbar';
import type { SiteHeaderProps } from '@/types/theme';

export function Navbar(props: SiteHeaderProps) {
return <SiteNavbar {...props} />;
}
